import { databaseTableActions } from '../actions'
import {
    getItemId,
    getTableColumns,
    normalizeFieldValue,
} from '../utils/tableHelpers'
import { TABLE_FIELDS } from '../constants'
import { useActions, useAppSelector } from '../../../store/hooks'
import { databasePageSelector } from '../../../store/slices/databasePage'
import { databaseSelector } from '../../../store/slices/database'

export function useDatabaseTable() {
    const selectedTable = useAppSelector(databasePageSelector.selectedTable)
    const tableData = useAppSelector(databaseSelector.tableData)
    const referenceOptions = useAppSelector(databaseSelector.referenceOptions)
    const referencesLoading = useAppSelector(databaseSelector.referencesLoading)
    const loading = useAppSelector(databaseSelector.loading)
    const saving = useAppSelector(databaseSelector.saving)
    const deleting = useAppSelector(databaseSelector.deleting)
    const error = useAppSelector(databaseSelector.error)
    const editError = useAppSelector(databaseSelector.editError)
    const editingRowId = useAppSelector(databasePageSelector.editingRowId)
    const editRowData = useAppSelector(databasePageSelector.editRowData)
    const isEditing = useAppSelector(databasePageSelector.isEditing)

    const {
        startEditingRow,
        cancelEditingRow,
        updateEditField,
        setDeleteModal,
        databaseUpdateRow,
    } = useActions(databaseTableActions)

    const columns = getTableColumns(tableData)

    const handleEditStart = (row) => {
        startEditingRow({
            rowId: getItemId(row),
            rowData: { ...row },
        })
    }

    const handleEditFieldChange = (field, value) => {
        const fieldType = TABLE_FIELDS[selectedTable]?.[field]
        updateEditField({
            field,
            value: normalizeFieldValue(value, fieldType),
        })
    }

    const handleEditSave = (row) => {
        databaseUpdateRow({
            table: selectedTable,
            id: getItemId(row),
            data: editRowData,
        })
    }

    const handleDelete = (row) => {
        setDeleteModal({ open: true, row })
    }

    const formatCellValue = (value) => {
        if (typeof value === 'boolean') {
            return value ? 'true' : 'false'
        }

        return value ?? '—'
    }

    return {
        selectedTable,
        tableData,
        columns,
        referenceOptions,
        referencesLoading,
        loading,
        saving,
        deleting,
        error,
        editError,
        editingRowId,
        editRowData,
        isEditing,
        handleEditStart,
        handleEditFieldChange,
        handleEditSave,
        handleDelete,
        cancelEditingRow,
        formatCellValue,
    }
}
